import { render, staticRenderFns } from "./lineArea.md?vue&type=template&id=317798f1&"
import script from "./lineArea.md?vue&type=script&lang=js&"
export * from "./lineArea.md?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/code/core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('317798f1')) {
      api.createRecord('317798f1', component.options)
    } else {
      api.reload('317798f1', component.options)
    }
    module.hot.accept("./lineArea.md?vue&type=template&id=317798f1&", function () {
      api.rerender('317798f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "website/views/more/area/lineArea.md"
export default component.exports